import React from 'react';
import { getRemotedbUrl } from '../../lib/ep.js';
import { injectIntl } from 'react-intl';

import ActionLink from '../builder/ActionLink.js';

import { useOwner } from '../context/context.js';

import OwnerMenu from '../ui_items/OwnerMenu.js';

const Link = ({ actual_section, ...props }) => {
	const _hash = props?.hash ?? false;
	const hash = (_hash !== false) ? ((typeof _hash == "string") ? _hash : _hash[0]) : false;

	const url = (hash !== false) ? getRemotedbUrl(`/emails/platform/${props.id}`, hash) : (props?.url ?? false);
	if(url === false) return null;
	let selected = false;
	if(hash !== false) {
		if(actual_section != '' && hash.indexOf(actual_section) > -1) {
			selected = true;
		} else if(actual_section.indexOf("edit/") > -1 && hash == '#') {
			selected = true;
		} else if((actual_section == '' || actual_section == 'notifications') && hash == '#') {
			selected = true;
		}
	}
	
	let custom_class = [];
	if(selected) custom_class.push('cursor');

	return (
		<ActionLink
			_href={url}
			_class={{other:custom_class.join(" ")}}
			icon={props.icon}
			_target={props?._target || '_self'}
		>{props.children}</ActionLink>
	)
};

const MailsMainMenu = (props) => {
	const owner = useOwner();

	const promotion = owner?.promotion?.Promotion ?? false;
	if(promotion === false) return null;

	const disabled_menu = (props.route == undefined) ? true : false;
	const current = (!disabled_menu) ? props.route.match.url : '';

	const route_props = {
		id:promotion.id,
		actual_section:current.substring(1),
	};

	let _s = {};

	/*_s.general = {
		title:"General",
		items:[{
			url:`/promotions/profile/${promotion.id}`,
			icon:'knk-home',
			selected:false,
			children:"Home",
		}],
	}*/

	_s.pages = {
		title:"Emails & Notifications",
		items:[{
			enabled:true,
			custom:<Link
						{...route_props}
						hash="#"
						icon="knk-send"
					>Emails & Notifications</Link>,
		}, {
			enabled:true,
			custom:<Link
						{...route_props}
						hash="settings"
						icon="knk-settings"
					>Settings</Link>,
		}, {
			enabled:true,
			custom:<Link
						{...route_props}
						hash="unsubscribed"
						icon="knk-reject-user"
					>Unsubscribers</Link>,
		}, {
			enabled:true,
			custom:<Link
						{...route_props}
						hash="search"
						icon="knk-find"
					>Search Email Tool</Link>,
		}, {
			enabled:true,
			custom:<Link
						{...route_props}
						url={`${window.zendesk_base_url}207884166`}
						icon="knk-help"
						_target="_blank"
					>Help</Link>,
		}],
	}

	return (
		<OwnerMenu sections={Object.values(_s)} />
	)
}

export default injectIntl(MailsMainMenu);